

import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Navbar from "../../Navbar/Navbar.jsx";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import baseURL from "../../config.js";
import { FaEdit } from "react-icons/fa";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Pagination,
  Box,
  Typography,
  Modal,
  TablePagination,
} from "@mui/material";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const VesselTableByVesselOwnerId = () => {
  const [shipDetails, setShipDetails] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [openModal, setOpenModal] = useState(false);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const { id } = useParams();
  const navigate = useNavigate();

  // Pagination states
      const [page, setPage] = useState(0);
      const [rowsPerPage, setRowsPerPage] = useState(10);

  useEffect(() => {
    const fetchShipDetails = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get(`${baseURL}/api/getVesselDetails/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        setShipDetails(response.data.data); 
        setTotalPages(response.data.totalPages); 
      } catch (error) {
        console.error("Error fetching ship details:", error);
      }
    };
    fetchShipDetails();
  }, [id]); 

  const filteredShips = shipDetails.filter(ship =>
    ship?.vesselname?.toLowerCase()?.includes(searchTerm.toLowerCase()) ||
    ship?.IMO_Number?.toString()?.includes(searchTerm)
  );
  
  // Calculate the current page's data
  const currentPageData = filteredShips ? 
  filteredShips.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) : 
  [];

// Handle page change
const handleChangePage = (event, newPage) => {
  setPage(newPage);
};

// Handle rows per page change
const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0); // Reset to first page when rows per page changes
};




  const handleOpenModal = (ship) => {
    if (ship) {
      const documents = Object.entries(ship)
        .filter(([key, value]) =>
          ["seagreement", "cdagreement", "pipolicydocument", "maritimelabourconvention", "fsdocument", "dmlcp1", "dmlc2", "SMD", "registryDocument", "Cargo_PassengerShipSafety", "MaximumLifeSavingAppliance"].includes(key) &&
          value
        )
        .map(([key, value]) => {
          const filePath = typeof value === "string" ? value : value?.filePath;
          return filePath
            ? {
                fileName: key, // Only the document key
                filePath: `${baseURL}/${filePath.replace(/\\/g, "/")}`,
              }
            : null;
        })
        .filter(Boolean);
  
      setSelectedDocuments(documents);
      setOpenModal(true); // Ensure the modal opens after setting state
    }
  };
  
  
  return (
    <>
      <Navbar />
      <div style={{ padding: "20px" }}>
      <h2 style={{ display: "none" }}>Vessel Table</h2> {/* Hidden if title is now centered below */}

<div
  style={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: "16px",
    gap: "10px",
  }}
>
  {/* Search Bar */}
  <TextField
    label="Search by Vessel Name or IMO Number"
    variant="outlined"
    size="small"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    sx={{ maxWidth: 300, backgroundColor: "#f5f5f5" }}
  />

  {/* Table Name */}
  <Typography variant="h6" fontWeight="bold" sx={{ flexGrow: 1, textAlign: "center" }}>
    Vessel Table
  </Typography>

  {/* Right Side Buttons */}
  <Box display="flex" alignItems="center" gap={2}>
    {/* Add Vessel Button */}
    <Link to={id ? `/vessel/${id}` : "/vessel"}>
      <button
        style={{
          padding: "8px 16px",
          background: "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "5px",
          cursor: "pointer",
        }}
      >
        Add Vessel
      </button>
    </Link>

    {/* Total Count */}
    <Typography fontWeight="bold">
      Total Vessel: {shipDetails.length}
    </Typography>
  </Box>
</div>


        <TableContainer component={Paper} style={{ marginTop: "20px" }}>
          <Table>
            <TableHead sx={{ backgroundColor: "#1976D2", height: "30px", "& th": { color: "white", fontWeight: "bold" }  }}>
              <TableRow>
              <TableCell sx={{ width: "5rem" }}>Sr. No.</TableCell>
                <TableCell>Ship Information</TableCell>
                <TableCell>Insurance Details</TableCell>
                <TableCell>Certificates</TableCell>
                <TableCell>Documents</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {currentPageData.map((ship, index) => (
                <TableRow key={index}>
                   <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Typography variant="body1"><strong>Name of Ship:</strong> {ship.vesselname}</Typography>
                      <Typography variant="body1"><strong>IMO Number:</strong> {ship.IMO_Number}</Typography>
                      <Typography variant="body1"><strong>Ship Type:</strong> {ship.vesseltype}</Typography>
                      <Typography variant="body1"><strong>Ship Flag:</strong> {ship.Flag}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Typography variant="body1"><strong>Pi Number:</strong> {ship.pipolicynumber}</Typography>
                      <Typography variant="body1"><strong>Policy Date:</strong> {new Date(ship.policydateofv).toLocaleDateString("en-GB")}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                      <Typography variant="body1"><strong>MLC Certificate Number:</strong> {ship.mlcCert}</Typography>
                      <Typography variant="body1"><strong>MLC Expiry Date:</strong> {new Date(ship.mlcExpiryDate).toLocaleDateString("en-GB")}</Typography>
                      <Typography variant="body1"><strong>MLC Issue Date:</strong> {new Date(ship.mlcIssueDate).toLocaleDateString("en-GB")}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => handleOpenModal(ship)}>
                      <PictureAsPdfIcon sx={{ color: "red" }} />
                    </IconButton>
                  </TableCell>
                  <TableCell>
                    <IconButton onClick={() => navigate('/vessel', { state: { vessel: ship } })}>
                      <FaEdit style={{ color: "#1976d2" }} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>

          {/* Pagination component */}
          <TablePagination
                          component="div"
                          count={filteredShips ? filteredShips.length : 0}
                          page={page}
                          onPageChange={handleChangePage}
                          rowsPerPage={rowsPerPage}
                          onRowsPerPageChange={handleChangeRowsPerPage}
                          rowsPerPageOptions={[5, 10, 25]}
                          sx={{ borderTop: "1px solid rgba(224, 224, 224, 1)" }}
                      />
        </TableContainer>
      
      </div>
      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "90%", sm: "60%", md: "50%" },
            maxHeight: "80vh",
            bgcolor: "white",
            boxShadow: 24,
            p: 3,
            borderRadius: 2,
            overflowY: "auto",
          }}
        >
          <Typography
            variant="h6"
            gutterBottom
            sx={{ textAlign: "center", mb: 2, fontWeight: "bold" }}
          >
            Vessel Documents
          </Typography>
          {selectedDocuments.length > 0 ? (
            selectedDocuments
              .map(doc => ({
                ...doc,
                filePath: doc.filePath.includes("/Documents/")
                  ? doc.filePath
                  : doc.filePath.replace("/vesselupload/", "/Documents/vesselupload/")
              }))
              .map((doc, index) => (
                <Paper
                  key={index}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    p: 2,
                    mb: 2,
                    boxShadow: 2,
                    borderRadius: 2,
                    transition: "0.3s",
                    "&:hover": { boxShadow: 4, bgcolor: "#f5f5f5" },
                  }}
                >
                  <Box display="flex" alignItems="center">
                    <PictureAsPdfIcon sx={{ color: "red", mr: 1 }} />
                    <Typography variant="body1">
                      {doc.fileName ? doc.fileName : "Unknown Document"}
                    </Typography>
                  </Box>

                  {/* Check if filePath exists and is valid */}
                  {doc.filePath && doc.filePath.trim() !== "" ? (
                    <Button
                      variant="contained"
                      color="primary"
                      href={doc.filePath}
                      target="_blank"
                      rel="noopener noreferrer"
                      size="small"
                      sx={{ textTransform: "none" }}
                    >
                      Download
                    </Button>
                  ) : (
                    <Typography variant="body2" color="textSecondary">
                      No File Available
                    </Typography>
                  )}
                </Paper>
              ))
          ) : (
            <Typography align="center" color="textSecondary">
              No documents available
            </Typography>
          )}




          <Box display="flex" justifyContent="center" mt={2}>
            <Button variant="contained" color="error" onClick={() => setOpenModal(false)}>
              Close
            </Button>
          </Box>
        </Box>
      </Modal>



      <ToastContainer />
    </>
  );
};

export default VesselTableByVesselOwnerId;
